(() => {
  if (window.MMCart) return;

  // Sections that only exist on the full /cart page. When a customer adds a
  // refill from the upsell while standing on /cart, the page behind the drawer
  // has to be re-rendered by Shopify so its prices, discounts and totals stay
  // authoritative.
  const PAGE_SECTIONS = ['cart-items', 'cart-footer', 'cart-upsell'];

  const pageSections = () => PAGE_SECTIONS.filter((id) => document.getElementById(`shopify-section-${id}`));

  const sectionList = () => ['mm-cart-drawer', 'cart-icon-bubble'].concat(pageSections()).join(',');

  const syncPage = (sections) => {
    if (!sections) return;
    pageSections().forEach((id) => {
      const html = sections[id];
      if (typeof html !== 'string') return;
      const host = document.getElementById(`shopify-section-${id}`);
      if (!host) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(`shopify-section-${id}`);
      if (fresh) host.innerHTML = fresh.innerHTML;
    });
  };

  window.MMCart = { sectionList, syncPage };

  // Dawn owns the quantity controls on /cart and only re-renders its own
  // sections, so our upsell went stale after a quantity change. Shopify also
  // splits a line when only part of it is discounted (12 refills become 9 at
  // full price and 3 at 50 DH), which changes the markup underneath us.
  // Watching Dawn's section and re-fetching ours from Shopify keeps the cart
  // the single source of truth for both.
  const watchCartPage = () => {
    const items = document.getElementById('shopify-section-cart-items');
    if (!items || !document.getElementById('shopify-section-cart-upsell')) return;
    let pending;
    const refresh = () => {
      clearTimeout(pending);
      pending = setTimeout(() => {
        fetch(`${window.Shopify.routes.root}?sections=cart-upsell`)
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(syncPage)
          .catch(() => {
            /* Dawn's own sections stay authoritative either way */
          });
      }, 200);
    };
    new MutationObserver(refresh).observe(items, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartPage);
  } else {
    watchCartPage();
  }

  // Shopify's checkout button and the COD app's button were both showing on
  // /cart. Hiding the native one outright is exactly what left the store
  // unable to take an order when the previous COD app silently stopped
  // injecting, so this is conditional and self-healing: the flag is only set
  // while the COD button is genuinely on the page, and it is removed the
  // moment that button goes away.
  const watchCodButton = () => {
    const root = document.documentElement;
    const sync = () => {
      const es = document.getElementById('es-popup-button');
      root.classList.toggle('mm-cod-live', !!es && es.offsetParent !== null);
    };
    sync();
    if (!document.body) return;
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
    // The app renders after its own script boots, which can be after ours.
    window.setTimeout(sync, 1500);
    window.setTimeout(sync, 4000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCodButton);
  } else {
    watchCodButton();
  }

  const drawer = () => document.querySelector('mm-cart-drawer');

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-mm-open-cart]');
    if (!opener) return;
    const d = drawer();
    if (!d) return;
    event.preventDefault();
    d.open(opener);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-mm-atc]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const feedback = form.querySelector('[data-mm-atc-feedback]');
    if (button) button.setAttribute('aria-disabled', 'true');
    if (feedback) feedback.hidden = true;

    const body = new FormData(form);
    body.append('sections', sectionList());
    body.append('sections_url', window.location.pathname);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || (data.status && data.status !== 200)) {
          if (feedback) {
            feedback.textContent = data.description || data.message || 'Ajout impossible pour le moment.';
            feedback.hidden = false;
          }
          return;
        }
        syncPage(data.sections);
        const d = drawer();
        if (d && data.sections) {
          d.render(data.sections);
          d.open(button);
        } else if (d) {
          d.refresh().then(() => d.open(button));
        } else {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      })
      .catch(() => {
        if (feedback) {
          feedback.textContent = 'Ajout impossible pour le moment. Réessayez dans un instant.';
          feedback.hidden = false;
        }
      })
      .finally(() => {
        if (button) button.removeAttribute('aria-disabled');
      });
  });
})();
